import React from "react";
import "../css/NotFound.css";

function NotFound() {
  return (
    <div className="container" id="nf">
      <svg
        width="35"
        height="35"
        viewBox="0 0 35 35"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          width="35"
          height="35"
          rx="17.5"
          fill="#F17228"
          fill-opacity="0.4"
        />
        <path
          d="M19.8203 17.25L23.3359 13.7344C23.793 13.3125 23.793 12.6094 23.3359 12.1875L22.5625 11.4141C22.1406 10.957 21.4375 10.957 21.0156 11.4141L17.5 14.9297L13.9492 11.4141C13.5273 10.957 12.8242 10.957 12.4023 11.4141L11.6289 12.1875C11.1719 12.6094 11.1719 13.3125 11.6289 13.7344L15.1445 17.25L11.6289 20.8008C11.1719 21.2227 11.1719 21.9258 11.6289 22.3477L12.4023 23.1211C12.8242 23.5781 13.5273 23.5781 13.9492 23.1211L17.5 19.6055L21.0156 23.1211C21.4375 23.5781 22.1406 23.5781 22.5625 23.1211L23.3359 22.3477C23.793 21.9258 23.793 21.2227 23.3359 20.8008L19.8203 17.25Z"
          fill="white"
        />
      </svg>

      <p id="nf1">Уучлаарай, систем ачааллахад алдаа гарлаа.</p>
    </div>
  );
}

export default NotFound;
